import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  list: null,

  article: {
    title_ru: '',
    title_en: '',
    description_ru: '',
    description_en: '',
    course: {
      title_ru: '',
      title_en: '',
    },
    article: {
      title_ru: '',
      title_en: '',
    },
  },
};

export const glossarySlice = createSlice({
  name: 'glossary',
  initialState,
  reducers: {
    setGlossaryList: (state, action) => {
      state.list = action.payload;
    },

    setArticle: (state, action) => {
      state.article = action.payload;
    },

    resetGlossary: () => initialState,
  },
});

export const {
  setGlossaryList,

  setArticle,

  resetGlossary,
} = glossarySlice.actions;

export default glossarySlice.reducer;
